export const UPLOAD_TAXONOMY_COMPLETED = 'TaxonomyUpload.uploadTaxonomyCompleted';

interface UploadTaxonomyCompleted {
  type: typeof UPLOAD_TAXONOMY_COMPLETED
}

export type TaxonomyUploadActionTypes
  = UploadTaxonomyCompleted
